<template>
	<div class="card">
		<div class="header">My Card</div>
		<div class="menu flex align-center">
			<div class="item edit">编辑</div>
			<div class="item">删除</div>
		</div>
		<div class="card_list flex">
			<div class="item">
				<img src="../../../assets/images/icon/card2.png" alt="">
			</div>
		</div>
		<div class="add_btn" @click="addStatus = true">添加银行卡</div>
		<div class="model" v-if="addStatus">
			<div class="model_content">
				<div class="model_header">
					<div class="title">添加银行卡</div>
					<img @click="addStatus = false" src="../../../assets/images/icon/close.png" alt="">
				</div>
				<div class="item flex align-center justify-center">
					<div class="name">持卡人姓名： </div>
					<div class="val">
						<input type="text">
					</div>
				</div>
				<div class="item flex align-center justify-center">
					<div class="name">银行卡账号：</div>
					<div class="val">
						<input type="text">
					</div>
				</div>
				<div class="item flex align-center justify-center">
					<div class="name">卡过期时间：</div>
					<div class="val">
						<input type="text">
					</div>
				</div>
				<div class="item flex align-center justify-center">
					<div class="name">卡背面后三位：</div>
					<div class="val">
						<input type="text">
					</div>
				</div>
				<div class="ensure" @click="addCard">确认</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				addStatus:false
			}
		},
		methods:{
			// 添加银行卡
			addCard(){
				this.addStatus = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.card{
		width: 1240px;
		min-height: 1300px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 0 40px 60px;
		.header{
			width: 100%;
			height: 90px;
			line-height: 90px;
			border-bottom: 1px solid #5C707A;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		.menu{
			padding-top: 50px;
			.item{
				width: 70px;
				text-align: center;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 400;
				color: #282E30;
				cursor: pointer;
				&.edit{
					border-right: 1px solid #282E30;
				}
			}
		}
		.card_list{
			margin-top: 20px;
			flex-wrap: wrap;
			.item{
				width: 379px;
				height: 168px;
				overflow: hidden;
				cursor: pointer;
				img{
					width: 100%;
					height: 100%;
				}
			}
		}
		.add_btn{
			width: 200px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			margin-top: 50px;
			line-height: 57px;
			text-align: center;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
		.model{
			position: fixed;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			background-color: rgba(0,0,0,0.2);
			.model_content{
				width: 1000px;
				height: 736px;
				background: #F7F2EB;
				border-radius: 10px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%,-50%);
				padding: 0 20px;
				.model_header{
					width: 100%;
					height: 90px;
					position: relative;
					border-bottom: 1px solid #5C707A;
					margin-bottom: 40px;
					.title{
						font-size: 30px;
						font-family: Source Han Sans CN;
						font-weight: 500;
						color: #282E30;
						line-height: 90px;
						text-align: center;
					}
					img{
						width: 29px;
						height: 28px;
						position: absolute;
						right: 0;
						top: 50%;
						transform: translateY(-50%);
						cursor: pointer;
					}
				}
				.item{
					margin-top: 20px;
					.name{
						width: 155px;
						font-size: 22px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						text-align: right;
						margin-right: 30px;
					}
					.val{
						width: 464px;
						height: 58px;
						border: 1px solid #282E30;
						border-radius: 10px;
						input{
							width: 100%;
							height: 100%;
							line-height: 58px;
							padding: 0 30px;
							font-size: 20px;
							font-family: Source Han Sans CN;
							font-weight: 500;
							color: #999999;
						}
					}
				}
				.ensure{
					width: 181px;
					height: 57px;
					background: #5C707A;
					border-radius: 29px;
					margin: 100px auto;
					line-height: 57px;
					text-align: center;
					font-size: 24px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					cursor: pointer;
				}
			}
			
		}
	}
</style>